<template>
  <div class="alert alert-danger alert-dismissable" v-if="Object.keys(errors).length">
    <template v-for="error in errors">
      <p v-for="v in error">{{v}}</p>
    </template>
  </div>
</template>
<script>
  export default {
    props: ['errors']
  }
</script>



// WEBPACK FOOTER //
// Error.vue?dd0e8b90